<ion-searchbar [placeholder]="searchPlaceholder" [disabled]="disabled" [debounce]="200" (ionInput)="onSearch($event)"
  class="country-selector__search" show-clear-button="focus">
</ion-searchbar>

<div class="country-selector__scroll">
  <ul class="country-selector__list" role="radiogroup" aria-label="Country">
    @for (c of filteredCountries(); track c.isoCode) {
    <li class="country-selector__list-item">
      <button type="button" class="country-selector__item" role="radio"
        [attr.aria-checked]="isSelected(c) ? 'true' : 'false'" [disabled]="disabled" (click)="select(c)">
        <div class="country-selector__row" sxRow sxAlign="center" sxGap="10px">
          <span class="country-selector__flag" aria-hidden="true">{{ c.flag }}</span>
          <span class="country-selector__name" sxFlex="1">{{ c.name }}</span>
          <span class="country-selector__radio" aria-hidden="true">
            <span class="country-selector__radio-outer">
              @if (isSelected(c)) {
              <span class="country-selector__radio-inner"></span>
              }
            </span>
          </span>
        </div>
      </button>
    </li>
    }
  </ul>
</div>